module.exports = __webpack_public_path__ + "img/loading-tips.7401c057.jpg";